import callApi from 'services'

export default {
  getCitiesList() {
    return callApi('addresses/cities', 'GET')
  },
}
